<template>
  <div class="mypage-point-expiration-date-page">
    <sub-header-section
      :pageTitle="$tc('MypagePage.MypagePointExpirationDatePage.pageTitle')"
      :backLink="`/${backLink}`"
    />

    <div class="mypage-point-expiration-date-page__body">
      <mypage-point-expiration-date-pane />
    </div>

    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import type VueRouter from 'vue-router'
import { defineComponent, inject } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import MypagePointExpirationDatePane from '@/components/MypagePointExpirationDatePage/MypagePointExpirationDatePane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'

/**
 * 戻るボタンを押した時の戻り先の型
 */
export type PointExpirationBackLinkType = 'mission' | 'mypage'

export default defineComponent({
  name: 'MypagePointExpirationDatePage',
  components: { GlobalNavigationPane, MypagePointExpirationDatePane, SubHeaderSection },
  setup() {
    const router = inject('router') as VueRouter

    const backLink: PointExpirationBackLinkType = router.currentRoute.query.backLink
      ? (router.currentRoute.query.backLink as PointExpirationBackLinkType)
      : 'mypage'

    return {
      backLink,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-point-expiration-date-page {
  height: calc(var(--screen-height) - 48px);

  &__body {
    height: calc(100% - 44px - 48px);
  }
}
</style>
